module.exports = __webpack_public_path__ + "static/MtrMen-8e0c92be8479a6ca4988e9f10cef6d3b.webp";